import { FilterChangeArgs, FilterKeys, SelectedFilters } from '../types';

export const handleMainFilterChange = (
  slug: string,
  value: string | [number, number],
  checked: boolean | undefined,
  selectedFilters: SelectedFilters,
  onFiltersChange?: (args: FilterChangeArgs, withUpdate?: boolean) => void,
  withUpdate?: boolean
) => {
  if (Array.isArray(value)) {
    if (onFiltersChange) {
      onFiltersChange(
        {
          key: FilterKeys.filters,
          slug,
          value
        },
        withUpdate
      );
    }
  } else {
    const currentValues = (selectedFilters[slug] as string[]) || [];
    let newValues: string[];

    if (Array.isArray(currentValues) && !Array.isArray(currentValues[0])) {
      newValues = [...currentValues];

      if (checked) {
        if (!newValues.includes(value)) newValues.push(value);
      } else {
        const idx = newValues.indexOf(value);
        if (idx !== -1) newValues.splice(idx, 1);
      }
    } else {
      newValues = checked ? [value] : [];
    }

    if (onFiltersChange) {
      onFiltersChange(
        {
          key: FilterKeys.filters,
          slug,
          value: newValues
        },
        withUpdate
      );
    }
  }
};
